import React, { useState } from 'react';
import { RcFile } from 'antd/lib/upload';
import { useDispatch, useSelector } from 'react-redux';
import { DetailingProjectContentBlock } from '../../styles';
import { UploadAreaContainer } from './styles';
import UploadArea from '../../../../../../components/UploadArea/Facelift';
import NewProjectModal from './NewProjectModal';
import { IFabricationProject } from '../../../../../../store/ducks/fabrication-projects/types';
import {
  getDefaultFabricationProjectItem,
  IDetailingProjectState,
  IFabricationProjectItem
} from '../../../../../../store/ducks/fabrication-purchase-order/types';
import { addToast } from '../../../../../../store/ducks/toast/actions';
import { EToastTypes } from '../../../../../../store/ducks/toast/types';
import { ApplicationState } from '../../../../../../store';

interface IDetailingProjectUploadFilesProps {
  contractNumber: string;
  detailingProjectState: IDetailingProjectState;
  setDetailingProjectState(detailingProjectState: IDetailingProjectState): void;
}

const DetailingProjectUploadFiles: React.FC<
  IDetailingProjectUploadFilesProps
> = ({ contractNumber, detailingProjectState, setDetailingProjectState }) => {
  const dispatch = useDispatch();

  const [canShowNewProjectModal, setCanShowNewProjectModal] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<RcFile[]>([]);

  const onCloseNewProjectModal = (
    uploadedProjects: IFabricationProject[],
    unsendedProjectsFileNames: string[]
  ) => {
    setUploadedFiles([]);
    setCanShowNewProjectModal(false);

    if (uploadedProjects.length > 0) {
      const message =
        uploadedProjects.length === 1
          ? `1 arquivo enviado com sucesso.`
          : `${uploadedProjects.length} arquivos enviados com sucesso.`;
      dispatch(
        addToast({
          message,
          type: EToastTypes.SUCCESS,
          durationInMS: 5000
        })
      );

      updateDetailingProjectState(uploadedProjects);
    }

    if (unsendedProjectsFileNames.length > 0) {
      unsendedProjectsFileNames.forEach((fileName) => {
        dispatch(
          addToast({
            message: `O arquivo: ${fileName} não foi enviado.`,
            type: EToastTypes.WARNING,
            durationInMS: 5000
          })
        );
      });
    }
  };

  const updateDetailingProjectState = (
    uploadedProjects: IFabricationProject[]
  ) => {
    const newDetailingProjectItens: IFabricationProjectItem[] =
      uploadedProjects.map((up) => {
        return {
          ...getDefaultFabricationProjectItem(),
          projectId: up.id,
          revision: up.revision || '',
          projectSelected: up
        };
      });

    let updatedItens: IFabricationProjectItem[] = [];

    if (
      detailingProjectState.itens.length === 1 &&
      !detailingProjectState.itens[0].projectId
    ) {
      updatedItens = newDetailingProjectItens;
    } else {
      updatedItens = [
        ...detailingProjectState.itens,
        ...newDetailingProjectItens
      ];
    }

    setDetailingProjectState({
      ...detailingProjectState,
      itens: updatedItens
    });
  };

  const projects = useSelector(
    (state: ApplicationState) => state.fabricationProjects.projects
  );

  const handleExistingProject = (filename: string) => {
    let existingProject: IFabricationProject | undefined;
    if (projects) {
      existingProject = projects.find(
        (p) => p.fileName === filename && !p.mockupId
      );
    }
    if (
      existingProject &&
      detailingProjectState.itens.filter(
        (i) => i.projectId === existingProject?.id
      ).length === 0
    ) {
      updateDetailingProjectState([existingProject]);
    }
  };

  return (
    <DetailingProjectContentBlock>
      <UploadAreaContainer isFacelift>
        <UploadArea
          acceptedFiles={['.dxf, .dwg, .dwf, .pdf']}
          disabled={false}
          loading={false}
          onFileListChange={(files) => {
            setUploadedFiles(files);
            setCanShowNewProjectModal(true);
          }}
          acceptMultipleFiles={true}
          title={'Enviar novo projeto'}
          subtitle={`Clique aqui ou arraste seus arquivos de projeto para esta área para adicionar. Formatos aceitos: dwg, .dxf, .dwf, .xls ou .pdf`}
          hideChips
        />
      </UploadAreaContainer>
      {canShowNewProjectModal && (
        <NewProjectModal
          contractNumber={contractNumber}
          uploadedFiles={uploadedFiles}
          closeModal={onCloseNewProjectModal}
          setExistingProject={(filename) => handleExistingProject(filename)}
        />
      )}
    </DetailingProjectContentBlock>
  );
};

export default DetailingProjectUploadFiles;
